module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dropdown', {
    attrs: {
      "name": "name",
      "is-a-dropdown": true,
      "button-name": "Create a new claim"
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.newFatalDependencyClaim
    }
  }, [_vm._v("Fatal Accident Dependency")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.newFatalEstateClaim
    }
  }, [_vm._v("Fatal Accident Estate")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.newLostClaim
    }
  }, [_vm._v("Lost Years")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.newPersonalClaim
    }
  }, [_vm._v("Personal Injury")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18b288e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dropdown/CreateANewClaim.vue
// module id = 1592
// module chunks = 0